import { ref } from 'vue';

export const useTimer = (initialTime = 60) => {
  const timeLeft = ref(initialTime);
  let timerInterval = 0;

  const startTimer = () => {
    if (timerInterval) clearInterval(timerInterval);

    timeLeft.value = initialTime;
    timerInterval = setInterval(() => {
      if (timeLeft.value > 0) {
        timeLeft.value--;
      } else {
        clearInterval(timerInterval);
      }
    }, 1000);
  };

  const stopTimer = () => {
    if (timerInterval) {
      clearInterval(timerInterval);
    }
  };

  return { timeLeft, startTimer, stopTimer };
}